// ServiceHero.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';

const ServiceHero = ({ breadcrumbs, title, description }) => {
  return (
    <section className="py-12 px-6 md:px-12 lg:px-24" style={{ backgroundColor: '#F5F0F1' }}>
      <div className="max-w-7xl mx-auto">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm text-gray-600 mb-6">
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={index}>
              {index > 0 && <span>|</span>}
              {crumb.link ? (
                <Link to={crumb.link} className="hover:text-[#E85D2C] transition-colors">
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-gray-900">{crumb.label}</span>
              )}
            </React.Fragment>
          ))}
        </div>
        
        {/* Main Content */}
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            {title}
          </h1>
          
          <p className="text-gray-700 font-light leading-relaxed mb-8">
            {description}
          </p>
          
          <a 
            href="tel:+61269272706"
            className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
          >
            <Phone size={20} />
            CALL: (02) 6927 2706
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
